import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import type { Building } from '@/typings/buildings/Building';
import type { Project } from '@/typings/projects/Project';
import type { Region } from '@/typings/regions/Region';
import type { Unit } from '@/typings/units/Unit';

export function useRentalLocalizedUrls() {
  const { locale } = useI18n();

  const rentUrl = computed(() => {
    return locale.value === 'fr-CA' ? '/location' : '/en/rental';
  });

  function getBuildingWizardUrl(building: Building) {
    return `${rentUrl.value}/${building.localizedRegionSlug}/${building.localizedProjectSlug}/${building.localizedSlug}`;
  }

  function getBuildingWizardUrlFromUnit(unit: Unit) {
    return `${rentUrl.value}/${unit.localizedRegionSlug}/${unit.localizedProjectSlug}/${unit.localizedBuildingSlug}`;
  }

  function getRegionWizardUrl(region: Region) {
    return `${rentUrl.value}/${region.localizedSlug}`;
  }

  function getRegionWizardUrlFromProject(project: Project) {
    return `${rentUrl.value}/${project.localizedRegionSlug}`;
  }

  function getProjectWizardUrl(project: Project) {
    return `${rentUrl.value}/${project.localizedRegionSlug}/${project.localizedSlug}`;
  }

  function getProjectWizardUrlFromBuilding(building: Building) {
    return `${rentUrl.value}/${building.localizedRegionSlug}/${building.localizedProjectSlug}`;
  }

  function getRentalUnitWizardUrl(unit: Unit) {
    return `${rentUrl.value}/${unit.localizedRegionSlug}/${unit.localizedProjectSlug}/${unit.localizedBuildingSlug}/${unit.localizedFloorSlug}/${unit.localizedSlug}`;
  }

  return {
    getBuildingWizardUrl,
    getBuildingWizardUrlFromUnit,
    getProjectWizardUrl,
    getProjectWizardUrlFromBuilding,
    getRegionWizardUrl,
    getRegionWizardUrlFromProject,
    getRentalUnitWizardUrl,
    rentalWizardFirstStepUrl: rentUrl.value,
    homeUrl: locale.value === 'fr-CA' ? '/' : '/en',
    rentUrl: rentUrl.value
  };
}
